import { Search } from "@mui/icons-material";
import { Box, InputAdornment, TextField, useMediaQuery } from "@mui/material";
import React from "react";

const SearchBox = ({ search, setSearch, startSearch, loading = false }) => {
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const mediumScreen = useMediaQuery((theme) => theme.breakpoints.between("sm", "lg")); // Tablet range
  
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 1,
        mb: 1,
        mx: smallScreen ? 2 : mediumScreen ? "50px" : "200px", // Mobile: 2, Tablet: 50px, Desktop: 200px
      }}
    >
      <TextField
        variant="outlined"
        placeholder="Search..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          // if (loading) {
          //   startSearch();
          // }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && search.length > 0) {
            startSearch();
            // navigate("/search", { state: { search } });
          }
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "9px",
            height: "50px",
            backgroundColor: "#fff",
            boxShadow: "0px 0px 6.9px 0px #0000001F",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFB79C",
              borderWidth: "1px",
            },
            "& fieldset": {
              borderColor: "#FFB79C",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFB79C",
            },
          },
          "& .MuiOutlinedInput-input::placeholder": {
            opacity: 0.24,
            fontFamily: "Poppins-Regular",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "18px",
            color: "#1C1C1C",
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              onClick={() => {
                if (search.length > 0) {
                  startSearch();
                }
              }}
            >
              <Search sx={{ color: "#e1e1e1" }} />
            </InputAdornment>
          ),
        }}
        fullWidth
      />
    </Box>
  );
};

export default SearchBox;
